/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT = 'PORTAL_SETTINGS_CONTEXT';
export const portalSettingsContextResource: RouteResource<ServiceDeskContext> =
	createResource<ServiceDeskContext>({
		type: RESOURCE_TYPE_PORTAL_SETTINGS_CONTEXT,
		getKey: () => 'state',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-portal-settings-context", jiraSpaEntry: "async-resource-portal-settings-context" */ './getData.tsx'
			),
	});

export type ServiceDeskContext = {
	announcementSettings: {
		canAgentsManageHelpCenterAnnouncement: boolean;
		canAgentsManagePortalAnnouncement: boolean;
	};
	serviceDeskOpenAccess: boolean;
	canAdministerJIRA: boolean;
	description: string;
	descriptionWiki: string;
	name: string;
	portalId: number;
	portalLogoUrl: string;
	projectId: number;
	projectKey: string;
	portalUrl: string;
	helpCenterUrl: string;
};
